import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { ChevronLeft, ChevronRight, Info } from "lucide-react";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";

const showToast = () => {
  toast("Future data is not available", {
    icon: <Info />,
    style: {
      border: "1px solid #FFB700",
      padding: "10px",
      color: "#FFB700",
      background: "#FFF0D6",
    },
    iconTheme: {
      primary: "#713200",
      secondary: "#FFF0D6",
    },
  });
};

const MonthNavigator = ({ date, onChange }) => {
  const [open, setOpen] = useState(false);
 

  const changeMonth = (type) => {
    const newDate = new Date(date);
    newDate.setDate(1);

    // safe month change
    newDate.setMonth(newDate.getMonth() + (type === "next" ? 1 : -1));

    const today = new Date();

    const newMonth = newDate.getMonth();
    const newYear = newDate.getFullYear();

    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // 🚫 block future month
    if (
      newYear > currentYear ||
      (newYear === currentYear && newMonth > currentMonth)
    ) {
      showToast();
      return;
    }

    onChange(newDate);
  };

  return (
    <div className="flex justify-between items-center relative">
      {/* PREV */}
      <button onClick={() => changeMonth("prev")}>
        <ChevronLeft />
      </button>

      {/* CURRENT DATE (CLICKABLE) */}
      <p
        className="font-medium cursor-pointer select-none"
        onClick={() => setOpen(!open)}
      >
        {date.toLocaleString("default", { month: "long", year: "numeric" })}
      </p>

      {/* NEXT */}
      <button onClick={() => changeMonth("next")}>
        <ChevronRight />
      </button>

      {/* 🔥 CALENDAR PICKER */}
      {/* {open && (
        <div className="absolute top-10 left-1/2 -translate-x-1/2 z-50">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-4 w-64">
            <DatePicker
              selected={date}
              onChange={(d) => {
                onChange(d);
                setOpen(false);
              }}
              inline
              showMonthYearPicker
              dateFormat="MMMM yyyy"
              // override all default styles
              calendarClassName="!bg-white !border-0 !shadow-none !rounded-2xl text-sm"
              dayClassName={() => "text-gray-700 font-medium"}
              monthClassName={(monthDate) =>
                date.getMonth() === monthDate.getMonth()
                  ? "!bg-[#FF6943] !text-white !rounded-lg"
                  : "hover:!bg-[#FFE0D6] !text-gray-700 !rounded-lg"
              }
              renderCustomHeader={({
                date,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div className="flex justify-between items-center mb-4">
                  <button
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                    className="p-1 rounded hover:bg-gray-100 text-[#FF6943]"
                  >
                    <ChevronLeft size={16} />
                  </button>

                  <span className="font-semibold text-gray-800">
                    {date.toLocaleString("default", {
                      month: "long",
                      year: "numeric",
                    })}
                  </span>

                  <button
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    className="p-1 rounded hover:bg-gray-100 text-[#FF6943]"
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              )}
              className="w-full bg-transparent"
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default MonthNavigator;
